var Sounds = function() {

	this.chime = new Audio();
	this.chime.src = "./audio/chime.wav";
  this.music = new Audio();
  this.music.src = "./audio/music.wav";
  this.music.loop = true;

};

module.exports = Sounds;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/sounds.js
 ** module id = 4
 ** module chunks = 0
 **/